import type { ReactNode, HTMLAttributes } from 'react';
import './Card.css';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Visual variant */
  variant?: 'default' | 'featured' | 'glass';
  /** Whether to add hover effects */
  hoverable?: boolean;
  /** Optional icon or visual element */
  icon?: ReactNode;
  /** Card title */
  title?: string;
  /** Card description */
  description?: string;
  /** Card content */
  children?: ReactNode;
}

/**
 * Card component for displaying content in elevated containers.
 */
export function Card({
  variant = 'default',
  hoverable = false,
  icon,
  title,
  description,
  children,
  className = '',
  ...props
}: CardProps) {
  const classes = ['card', `card-${variant}`, hoverable && 'card-hoverable', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...props}>
      {icon && <div className="card-icon">{icon}</div>}
      {title && <h3 className="card-title">{title}</h3>}
      {description && <p className="card-description">{description}</p>}
      {children}
    </div>
  );
}
